import React from 'react'

export default () => {
  return (
    <hr className="dropdown-divider" />
  )
}



// WEBPACK FOOTER //
// ./src/components/DropdownDivider/DropdownDivider.js